export default __webpack_public_path__ + "img/Inter-ExtraBold_4378ab4.woff2";